import React from "react";
import { Autocomplete, Box, CircularProgress, TextField, Typography } from "@mui/material";
import { formatINR, userLabel } from "./addMoneyUtils";
import { inputSx } from "./parts";

// Shared by the form (pick who to credit) and the history filter ("All users").
const UserAutocomplete = ({
  id,
  value,
  onChange,
  onBlur,
  options,
  loading,
  disabled,
  placeholder,
  error,
  helperText,
  ariaLabel,
}) => (
  <Autocomplete
    id={id}
    size="small"
    fullWidth
    autoHighlight
    openOnFocus
    options={options}
    value={value}
    loading={loading}
    disabled={disabled}
    onChange={(_, option) => onChange(option)}
    onBlur={onBlur}
    getOptionLabel={userLabel}
    isOptionEqualToValue={(option, selected) => option._id === selected._id}
    loadingText="Loading users…"
    noOptionsText={options.length ? "No user matches your search" : "No users available"}
    renderOption={(props, option) => (
      <Box component="li" {...props} key={option._id} sx={{ display: "block !important", py: "6px !important" }}>
        <Typography noWrap sx={{ fontFamily: "Inter", fontSize: "13px", color: "#667085" }}>
          <Box component="span" sx={{ fontWeight: 600, color: "#101828" }}>
            {option.name}
          </Box>
          {[option.mobileNumber, option.email].filter(Boolean).map((part) => ` · ${part}`)}
        </Typography>
        <Typography sx={{ fontFamily: "Inter", fontSize: "12px", color: "#667085" }}>
          {option.adminName ? (
            <>
              Admin{" "}
              <Box component="span" sx={{ fontWeight: 600, color: "#344054" }}>
                {option.adminName}
              </Box>
              {" · "}
            </>
          ) : null}
          Current balance{" "}
          <Box component="span" sx={{ fontWeight: 600, color: "#1E3A5F" }}>
            {formatINR(option.balance)}
          </Box>
        </Typography>
      </Box>
    )}
    renderInput={(params) => (
      <TextField
        {...params}
        placeholder={placeholder}
        error={error}
        helperText={helperText}
        inputProps={{ ...params.inputProps, "aria-label": ariaLabel }}
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {loading ? <CircularProgress size={16} sx={{ color: "#1E3A5F" }} /> : null}
              {params.InputProps.endAdornment}
            </>
          ),
        }}
        sx={inputSx}
      />
    )}
  />
);

export default UserAutocomplete;
